"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ApiReportGenerateObjectCalendarView = _interopRequireDefault(require("./ApiReportGenerateObjectCalendarView"));
var _ApiReportGenerateObjectQuestionnairesView = _interopRequireDefault(require("./ApiReportGenerateObjectQuestionnairesView"));
var _PurchaseParams = _interopRequireDefault(require("./PurchaseParams"));
var _UserSettingsRecord = _interopRequireDefault(require("./UserSettingsRecord"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The ApiReportGenerateObject model module.
 * @module model/ApiReportGenerateObject
 * @version 4.0.0
 */
var ApiReportGenerateObject = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>ApiReportGenerateObject</code>.
   * @alias module:model/ApiReportGenerateObject
   */
  function ApiReportGenerateObject() {
    _classCallCheck(this, ApiReportGenerateObject);
    ApiReportGenerateObject.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(ApiReportGenerateObject, null, [{
    key: "initialize",
    value: function initialize(obj) {
      obj['pkg_name'] = 'Manage My Pain WEB';
      obj['change_values'] = '0';
      obj['cover_page'] = '1';
    }

    /**
     * Constructs a <code>ApiReportGenerateObject</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ApiReportGenerateObject} obj Optional instance to populate.
     * @return {module:model/ApiReportGenerateObject} The populated <code>ApiReportGenerateObject</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new ApiReportGenerateObject();
        if (data.hasOwnProperty('pkg_name')) {
          obj['pkg_name'] = _ApiClient["default"].convertToType(data['pkg_name'], 'String');
        }
        if (data.hasOwnProperty('filter_settings')) {
          obj['filter_settings'] = _UserSettingsRecord["default"].constructFromObject(data['filter_settings']);
        }
        if (data.hasOwnProperty('pain_summary')) {
          obj['pain_summary'] = _ApiClient["default"].convertToType(data['pain_summary'], 'String');
        }
        if (data.hasOwnProperty('filter_summary')) {
          obj['filter_summary'] = _ApiClient["default"].convertToType(data['filter_summary'], 'String');
        }
        if (data.hasOwnProperty('patient_profile')) {
          obj['patient_profile'] = _ApiClient["default"].convertToType(data['patient_profile'], ['String']);
        }
        if (data.hasOwnProperty('charts_view')) {
          obj['charts_view'] = _ApiClient["default"].convertToType(data['charts_view'], ['String']);
        }
        if (data.hasOwnProperty('timeline_view')) {
          obj['timeline_view'] = _ApiClient["default"].convertToType(data['timeline_view'], ['String']);
        }
        if (data.hasOwnProperty('pain_details')) {
          obj['pain_details'] = _ApiClient["default"].convertToType(data['pain_details'], [Object]);
        }
        if (data.hasOwnProperty('calendar_view')) {
          obj['calendar_view'] = _ApiReportGenerateObjectCalendarView["default"].constructFromObject(data['calendar_view']);
        }
        if (data.hasOwnProperty('questionnaires_view')) {
          obj['questionnaires_view'] = _ApiReportGenerateObjectQuestionnairesView["default"].constructFromObject(data['questionnaires_view']);
        }
        if (data.hasOwnProperty('change_values')) {
          obj['change_values'] = _ApiClient["default"].convertToType(data['change_values'], 'String');
        }
        if (data.hasOwnProperty('cover_page')) {
          obj['cover_page'] = _ApiClient["default"].convertToType(data['cover_page'], 'String');
        }
        if (data.hasOwnProperty('compare_to_start_date')) {
          obj['compare_to_start_date'] = _ApiClient["default"].convertToType(data['compare_to_start_date'], 'Number');
        }
        if (data.hasOwnProperty('compare_to_start_offset')) {
          obj['compare_to_start_offset'] = _ApiClient["default"].convertToType(data['compare_to_start_offset'], 'Number');
        }
        if (data.hasOwnProperty('compare_to_end_date')) {
          obj['compare_to_end_date'] = _ApiClient["default"].convertToType(data['compare_to_end_date'], 'Number');
        }
        if (data.hasOwnProperty('compare_to_end_offset')) {
          obj['compare_to_end_offset'] = _ApiClient["default"].convertToType(data['compare_to_end_offset'], 'Number');
        }
        if (data.hasOwnProperty('start_offset')) {
          obj['start_offset'] = _ApiClient["default"].convertToType(data['start_offset'], 'Number');
        }
        if (data.hasOwnProperty('end_offset')) {
          obj['end_offset'] = _ApiClient["default"].convertToType(data['end_offset'], 'Number');
        }
        if (data.hasOwnProperty('time_offset')) {
          obj['time_offset'] = _ApiClient["default"].convertToType(data['time_offset'], 'Number');
        }
        if (data.hasOwnProperty('tz')) {
          obj['tz'] = _ApiClient["default"].convertToType(data['tz'], 'String');
        }
        if (data.hasOwnProperty('purchase')) {
          obj['purchase'] = _PurchaseParams["default"].constructFromObject(data['purchase']);
        }
        if (data.hasOwnProperty('is_check_records')) {
          obj['is_check_records'] = _ApiClient["default"].convertToType(data['is_check_records'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ApiReportGenerateObject</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ApiReportGenerateObject</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['pkg_name'] && !(typeof data['pkg_name'] === 'string' || data['pkg_name'] instanceof String)) {
        throw new Error("Expected the field `pkg_name` to be a primitive type in the JSON string but got " + data['pkg_name']);
      }
      // validate the optional field `filter_settings`
      if (data['filter_settings']) {
        // data not null
        _UserSettingsRecord["default"].validateJSON(data['filter_settings']);
      }
      // ensure the json data is a string
      if (data['pain_summary'] && !(typeof data['pain_summary'] === 'string' || data['pain_summary'] instanceof String)) {
        throw new Error("Expected the field `pain_summary` to be a primitive type in the JSON string but got " + data['pain_summary']);
      }
      // ensure the json data is a string
      if (data['filter_summary'] && !(typeof data['filter_summary'] === 'string' || data['filter_summary'] instanceof String)) {
        throw new Error("Expected the field `filter_summary` to be a primitive type in the JSON string but got " + data['filter_summary']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['patient_profile'])) {
        throw new Error("Expected the field `patient_profile` to be an array in the JSON data but got " + data['patient_profile']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['charts_view'])) {
        throw new Error("Expected the field `charts_view` to be an array in the JSON data but got " + data['charts_view']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['timeline_view'])) {
        throw new Error("Expected the field `timeline_view` to be an array in the JSON data but got " + data['timeline_view']);
      }
      // ensure the json data is an array
      if (!Array.isArray(data['pain_details'])) {
        throw new Error("Expected the field `pain_details` to be an array in the JSON data but got " + data['pain_details']);
      }
      // validate the optional field `calendar_view`
      if (data['calendar_view']) {
        // data not null
        _ApiReportGenerateObjectCalendarView["default"].validateJSON(data['calendar_view']);
      }
      // validate the optional field `questionnaires_view`
      if (data['questionnaires_view']) {
        // data not null
        _ApiReportGenerateObjectQuestionnairesView["default"].validateJSON(data['questionnaires_view']);
      }
      // ensure the json data is a string
      if (data['change_values'] && !(typeof data['change_values'] === 'string' || data['change_values'] instanceof String)) {
        throw new Error("Expected the field `change_values` to be a primitive type in the JSON string but got " + data['change_values']);
      }
      // ensure the json data is a string
      if (data['cover_page'] && !(typeof data['cover_page'] === 'string' || data['cover_page'] instanceof String)) {
        throw new Error("Expected the field `cover_page` to be a primitive type in the JSON string but got " + data['cover_page']);
      }
      // ensure the json data is a string
      if (data['tz'] && !(typeof data['tz'] === 'string' || data['tz'] instanceof String)) {
        throw new Error("Expected the field `tz` to be a primitive type in the JSON string but got " + data['tz']);
      }
      // validate the optional field `purchase`
      if (data['purchase']) {
        // data not null
        _PurchaseParams["default"].validateJSON(data['purchase']);
      }
      // ensure the json data is a string
      if (data['is_check_records'] && !(typeof data['is_check_records'] === 'string' || data['is_check_records'] instanceof String)) {
        throw new Error("Expected the field `is_check_records` to be a primitive type in the JSON string but got " + data['is_check_records']);
      }
      return true;
    }
  }]);
}();
/**
 * Application name, always equals to 'Manage My Pain WEB' since `generate-report` is only used for the webapp
 * @member {String} pkg_name
 * @default 'Manage My Pain WEB'
 */
ApiReportGenerateObject.prototype['pkg_name'] = 'Manage My Pain WEB';

/**
 * @member {module:model/UserSettingsRecord} filter_settings
 */
ApiReportGenerateObject.prototype['filter_settings'] = undefined;

/**
 * This value determines whether or not to include Summary section to the report
 * @member {module:model/ApiReportGenerateObject.PainSummaryEnum} pain_summary
 */
ApiReportGenerateObject.prototype['pain_summary'] = undefined;

/**
 * This value determines whether or not to include Filter summary section to the report. Can be set to '1' ONLY IF something is provided in `filter_settings`
 * @member {module:model/ApiReportGenerateObject.FilterSummaryEnum} filter_summary
 */
ApiReportGenerateObject.prototype['filter_summary'] = undefined;

/**
 * If not empty, Patient profile section will be included in the report and contain specified fields
 * @member {Array.<String>} patient_profile
 */
ApiReportGenerateObject.prototype['patient_profile'] = undefined;

/**
 * If not empty, Chart view section will be included in the report and contain specified sections
 * @member {Array.<String>} charts_view
 */
ApiReportGenerateObject.prototype['charts_view'] = undefined;

/**
 * If not empty, Timeline view section will be included in the report and contain specified graphs
 * @member {Array.<String>} timeline_view
 */
ApiReportGenerateObject.prototype['timeline_view'] = undefined;

/**
 * If not empty, Record details section will be included in the report and contain specified sections. If `sort_order` and `sort_by` are provided, then displaying records will be sorted by specified `sort_by` record field (e.g. `timing`, `pain_record_type`, etc.) and ordered with specified `sort_order` (can be `desc` or `asc`)
 * @member {Array.<Object>} pain_details
 */
ApiReportGenerateObject.prototype['pain_details'] = undefined;

/**
 * @member {module:model/ApiReportGenerateObjectCalendarView} calendar_view
 */
ApiReportGenerateObject.prototype['calendar_view'] = undefined;

/**
 * @member {module:model/ApiReportGenerateObjectQuestionnairesView} questionnaires_view
 */
ApiReportGenerateObject.prototype['questionnaires_view'] = undefined;

/**
 * This parameter determines whether or not to show change values on the Insights page. Change values show the absolute difference between specific values (e.g. Average pain severity) in the current period of time and in the previous period. Currently this parameter isn't requested in Android app, or Webapp.
 * @member {module:model/ApiReportGenerateObject.ChangeValuesEnum} change_values
 * @default '0'
 */
ApiReportGenerateObject.prototype['change_values'] = '0';

/**
 * This value determines whether or not to include Cover page section to the report. If not provided - this section will be included by default.
 * @member {module:model/ApiReportGenerateObject.CoverPageEnum} cover_page
 * @default '1'
 */
ApiReportGenerateObject.prototype['cover_page'] = '1';

/**
 * Only required if `change_values` is set to 1. This parameter specifies the start time of the previous period represented as the number of milliseconds between user's local device time and 1970-01-01 (Unix Time). It satisfies the following formula `compare_to_start_date_UTC + compare_to_start_offset = compare_to_start_date`. See example of a `compare_to_start_date` for February 1, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_start_date
 */
ApiReportGenerateObject.prototype['compare_to_start_date'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC on the previous period's start date. It satisfies the following formula `compare_to_start_date_UTC + compare_to_start_offset = compare_to_start_date`. See example of a `compare_to_start_offset` on February 1, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_start_offset
 */
ApiReportGenerateObject.prototype['compare_to_start_offset'] = undefined;

/**
 * Only required if `change_values` is set to 1. This parameter specifies the start time of the previous period represented as the number of milliseconds between user's local device time and 1970-01-01 (Unix Time). It satisfies the following formula `compare_to_end_date_UTC + compare_to_end_offset = compare_to_end_date`. See example of a `compare_to_end_date` for February 28, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_end_date
 */
ApiReportGenerateObject.prototype['compare_to_end_date'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC on the previous period's end date. It satisfies the following formula `compare_to_end_date_UTC + compare_to_end_offset = compare_to_end_date`. See example of a `compare_to_end_offset` on February 28, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} compare_to_end_offset
 */
ApiReportGenerateObject.prototype['compare_to_end_offset'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC at the start date. It satisfies the following formula `start_time_UTC + start_offset = start_date`. See example of an `end_date` of March 1, 2018 at 2:34AM in EST (UTC-5:00).
 * @member {Number} start_offset
 */
ApiReportGenerateObject.prototype['start_offset'] = undefined;

/**
 * Number of milliseconds between the requesting user's local device and UTC at the end date. It satisfies the following formula `end_time_UTC + end_offset = end_date`. See example of an `end_date` of March 30, 2018 at 2:34AM in EDT (UTC-4:00), which is EST during DST.
 * @member {Number} end_offset
 */
ApiReportGenerateObject.prototype['end_offset'] = undefined;

/**
 * Number of milliseconds between the creating user's local device and UTC at the time the request was submitted. It satisfies the following formula `UTC + time_offset = timing`. See example of a request submitted by a user on April 1, 2018 at 2:34AM in EDT (UTC-4:00), which is EST during DST.
 * @member {Number} time_offset
 */
ApiReportGenerateObject.prototype['time_offset'] = undefined;

/**
 * @member {String} tz
 */
ApiReportGenerateObject.prototype['tz'] = undefined;

/**
 * @member {module:model/PurchaseParams} purchase
 */
ApiReportGenerateObject.prototype['purchase'] = undefined;

/**
 * Enables test mode. If provided and set to true - PDF itself will not be generated, 2 sets of record IDs will be returned instead (current and compareTo periods). Used in automated test-cases.
 * @member {String} is_check_records
 */
ApiReportGenerateObject.prototype['is_check_records'] = undefined;

/**
 * Allowed values for the <code>pain_summary</code> property.
 * @enum {String}
 * @readonly
 */
ApiReportGenerateObject['PainSummaryEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};

/**
 * Allowed values for the <code>filter_summary</code> property.
 * @enum {String}
 * @readonly
 */
ApiReportGenerateObject['FilterSummaryEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};

/**
 * Allowed values for the <code>change_values</code> property.
 * @enum {String}
 * @readonly
 */
ApiReportGenerateObject['ChangeValuesEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};

/**
 * Allowed values for the <code>cover_page</code> property.
 * @enum {String}
 * @readonly
 */
ApiReportGenerateObject['CoverPageEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};
var _default = exports["default"] = ApiReportGenerateObject;